import React, { useEffect } from 'react';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';
import WordCollection from '../../utils/question/wordCollection';
import PassageFill from '../../utils/question/passageFill';
import { appendScript } from '../../../../utils/appendScript';
import { removeScript } from '../../../../utils/removeScript';

const mapStateToProps = (state) => {
	const { leftSectionProps, isFeedback } = state.rootReducer.testPageDetails;

	return {
		leftSectionProps,
		isFeedback,
	};
};

const Cloze = ({
	leftSectionProps: { wordbank, questionId, prompt },
	isFeedback,
}) => {
	useEffect(() => {
		if (!isFeedback) {
			appendScript('cloze');
		}
		return () => {
			removeScript('cloze');
		};
	}, [wordbank, isFeedback]);

	return (
		<section className="que-container ">
			<section className="quiz-page-content">
				<TopQuestion />
				<p
					style={{ display: 'none' }}
					className="error test_validation"
					id="errorWordcloudPage"
				>
					Please answer the question
				</p>
				<section className="quiz-area-options">
					<PassageFill />
				</section>
				<section className="quiz-area-options">
					<h6>{prompt}</h6>
					<WordCollection wordbank={wordbank} questionId={questionId} />
					<div className="clearfix step-toptions-wrapper" id="div_90681">
						<div id="resetClozeButton" className="word-question-reset resetButton">
							Reset <i className="fa fa-repeat" aria-hidden="true"></i>
						</div>
					</div>
					<input type="hidden" id="clozeResponse" name="clozeResponse" />
				</section>
			</section>
		</section>
	);
};

export default connect(mapStateToProps)(Cloze);
